import React, { Component } from 'react';
import FadeIn from 'react-fade-in';
import DetailBlock from './DetailBlock';
import { numberWithCommas } from '../util/util';

// Icons
import IconRenconcilation from '../images/icon/icon-transfer-blue.png';
import IconStatement from '../images/icon/icon-statements-blue.png';
import IconTransfer from '../images/icon/icon-dollar-moving-fast-v2-94x73-2kb.jpg';
import IconLockbox from '../images/icon/icon-reconciliations-blue.png';
import IconResearch from '../images/icon/icon-research-blue.png';
import IconPositivePay from '../images/icon/icon-positive-pay.png';
import IconStopPayment from '../images/icon/icon-stoppayment-blue.png';
import IconNewAccount from '../images/icon/icon-new-account-v2.png';
import IconAccountStaff from '../images/icon/icon-accounting-v2.png';

class Details extends Component {
  constructor(props) {
    super();
    this.state = {
      fadeOut: false,
      close: false,
    };
  }

  componentDidMount() {
    this.timer = setTimeout(() => this.setState({ fadeOut: true }), 10000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  closePopUp() {
    this.setState({ close: true });
  }

  render() {
    let appName = this.props.appName;
    let totalTimeSaved = this.props.totalSaved;
    let totalSaving = this.props.totalSaving;
    let reconciliations = this.props.reconciliations;
    let statement = this.props.statement;
    let transfer = this.props.transfer;
    let lockbox = this.props.lockbox;
    let research = this.props.research;
    let positivePay = this.props.positivePay;
    let stopPayment = this.props.stopPayment;
    let newAccount = this.props.newAccount;
    let accountStaff = this.props.accountStaff;

    return (
      <FadeIn>
        <div className="print-hide mobile-header underline">
          <div className="row">
            <div className="col-5">
              <div className="HOA-Logo">
                <img src="https://www.ppbi.com/custom/ppbi3/calculator/static/media/PPBI_HOA.e6dbcd3a.svg" alt="Pacific Premier Bank HOA &amp; Property Banking" />
              </div>
            </div>
          </div>
          <div className="row justify-content-center text-center">
            <div className="col-12">
              <h1 className='text-center'>
                Pacific Premier API Banking<sup>SM</sup><br />
                {appName}
              </h1>
            </div>
          </div>
        </div>

        <div className='row justify-content-center mb-5'>
          <div className='col-lg-11'>
            <div className='total-saving total row'>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <div className='result-box bg-color-light'>
                  <h2 className='font-color-primary'>Estimated Total Time Saved</h2>
                  <div className='text-center result-value'>
                    <strong>
                      <span className='font-color-secondary'>{numberWithCommas(totalTimeSaved.toFixed(1))}</span> Hours/Month
                    </strong>
                  </div>
                </div>
              </div>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <div className='result-box bg-green'>
                  <h2>Estimated Total Money Saved</h2>
                  <div className='text-center result-value'>
                    <strong>
                      <span>{totalSaving}</span> Per Year
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='app-step-container'>
          <h2 className='text-center main-title'>
            Approximate Savings Per Month Details
          </h2>

          <div className='wrapper'>
            <div className='row'>
              <div className='print col-sm-12 col-md-4 col-lg-4'>
                <DetailBlock
                  title='Reconciliations'
                  propValue={reconciliations}
                  unit='Mins'
                  image={IconRenconcilation}
                />
              </div>
              <div className='print col-sm-12 col-md-4 col-lg-4'>
                <DetailBlock
                  title='Statements'
                  propValue={statement}
                  unit='Mins'
                  image={IconStatement}
                />
              </div>
              <div className='print col-sm-12 col-md-4 col-lg-4'>
                <DetailBlock
                  title='Transfers'
                  propValue={transfer}
                  unit='Mins'
                  image={IconTransfer}
                />
              </div>
              <div className='print col-sm-12 col-md-4 col-lg-4'>
                <DetailBlock
                  title='Lockbox'
                  propValue={lockbox}
                  unit='Mins'
                  image={IconLockbox}
                />
              </div>
              <div className='print col-sm-12 col-md-4 col-lg-4'>
                <DetailBlock
                  title='Positive Pay'
                  propValue={positivePay}
                  unit='Mins'
                  image={IconPositivePay}
                />
              </div>
              <div className='print col-sm-12 col-md-4 col-lg-4'>
                <DetailBlock
                  title='Research'
                  propValue={research}
                  unit='Mins'
                  image={IconResearch}
                />
              </div>
              <div className='print col-sm-12 col-md-4 col-lg-4'>
                <DetailBlock
                  title='New Accounts'
                  propValue={newAccount}
                  unit='Mins'
                  image={IconNewAccount}
                />
              </div>
              <div className='print col-sm-12 col-md-4 col-lg-4'>
                <DetailBlock
                  title='Accounting Staff'
                  propValue={accountStaff}
                  unit='Per Month'
                  image={IconAccountStaff}
                />
              </div>
              <div className='print col-sm-12 col-md-4 col-lg-4'>
                <DetailBlock
                  title='Stop Payments'
                  propValue={stopPayment}
                  unit='Mins'
                  image={IconStopPayment}
                />
              </div>
            </div>

          </div>
        </div>
        <div className="pt-5 contact text-center">
          <h4 className="color-red">Get Started Today.</h4>
          For more information about our HOA and Property Banking Solutions, please contact our team via email at <a href="mailto:hoasolutions@ppbi.com" target="_blank" rel="noopener noreferrer">hoasolutions@ppbi.com</a> or call us <a href="tel:8662116613">866.211.6613</a>.<br />
          <br />
        </div>
      </FadeIn>


    );
  }
}

export default Details;
